import React from "react"
import useIpdReleaseHook from "./ipdReleaseHook";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import IpdPatient from "./ipdPatient";
import IpdVoucherList from "./ipdVoucherTable";
import Button from '@mui/material/Button';
import "./ipdRelease.scss";

const IpdRelease = () => {
    const { ipdReleaseListState, handleSelectIpd, selectIpd, 
        filterSelectedIpd, voucherSelectedIpd, sumAmount, calculateDiscount, finalAmount,
        handleApprove, setReamrks, discount
        
     } = useIpdReleaseHook();


    return (
        <>
            <div className="ipd-release">
                <div className="mt-2 ml-4">
                    <h4>IPD Approval</h4>
                    {/* <div className="back-btn"
                    // onClick={handleGoBack}
                    >
                        <ArrowBackIcon className="arrow-color" />
                        <span
                            style={{ cursor: "pointer" }}
                            className="anchr-link header-text mt-3 mb-3"
                        >
                            {"Back"}
                        </span>
                    </div> */}
                </div>
                <div className="d-flex">
                    <div className="form-group col-md-6 mt-4">
                        <label for="lname" className="control-label col-sm">Select Ipd</label>
                        <div class="col-auto">
                            <div class="input-group mb-2">
                                <select
                                    // onBlur={handleBlur}
                                    className={"form-control"}
                                    selected={selectIpd}
                                    value={selectIpd}
                                    onChange={(e) => handleSelectIpd(e, ipdReleaseListState)}
                                    required
                                    name="gender"
                                >
                                    <option></option>
                                    {
                                        ipdReleaseListState && ipdReleaseListState?.map((ele) => (
                                            <option value={ele?.ipdid}>{ele?.ipdNo}-{ele?.name}</option>
                                        ))
                                    }

                                </select>
                                <div class="invalid-feedback">
                                    Please provide a valid gender.
                                </div>
                            </div>
                        </div>
                    </div>
                    {filterSelectedIpd?.length > 0 && <div className="form-group col-md-6 mt-4">
                        <IpdPatient filterSelectedIpd={filterSelectedIpd} />
                    </div>}
                </div>
            </div>
            {voucherSelectedIpd?.length > 0 &&
                <>
                    <div className="button-sub d-flex justify-content-end mr-4 mt-2">
                        <Button
                            variant='contained'
                            color='primary'
                            className=""
                            onClick={handleApprove}
                        >
                            Submit
                        </Button>
                    </div>

                    <div className="bill-ammount d-flex flex-wrap">
                        <div className="form-group col-md-4 mt-4">
                            <label for="lname" className="control-label col-sm">Bill Amount</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <input
                                        // onBlur={handleBlur}
                                        type="text"
                                        required
                                        className={"form-control"
                                        }
                                        id="cardHolderName" placeholder="Bill Amount"
                                        name="billAmount"
                                        disabled={true}
                                        value={sumAmount}
                                    // onChange={(e) => handleIPDChange(e, null, "nestedObject")}
                                    />

                                    <div class="invalid-feedback">
                                        Please provide a valid gender.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="form-group col-md-4 mt-4">
                            <label for="lname" className="control-label col-sm">Discount</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <input
                                        // onBlur={handleBlur}
                                        type="text"
                                        required
                                        className={"form-control"
                                        }
                                        id="Discount" placeholder="Discount"
                                        name="discount"
                                        value={discount}
                                        onChange={(e) => calculateDiscount(e)}
                                    />

                                    <div class="invalid-feedback">
                                        Please provide a valid gender.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="form-group col-md-4 mt-4">
                            <label for="lname" className="control-label col-sm">Final Amount</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <input
                                        type="text"
                                        required
                                        className={"form-control"
                                        }
                                        id="Discount" placeholder="Final Amount"
                                        name="finalAmount"
                                        disabled={true}
                                        value={finalAmount ? finalAmount : sumAmount}
                                    />

                                    <div class="invalid-feedback">
                                        Please provide a valid gender.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="form-group col-md-4 mt-4">
                            <label for="lname" className="control-label col-sm">Remarks*</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <textarea id="txtid"
                                        name="remarks"
                                        className={"form-control"}
                                        rows="4" cols="50" maxlength="200" 
                                        onChange={(e) =>setReamrks(e?.target.value)}
                                        />



                                    <div class="invalid-feedback">
                                        Please provide a valid gender.
                                    </div>
                                </div>
                            </div>
                        </div>



                    </div>
                </>}

            {voucherSelectedIpd?.length > 0 && <IpdVoucherList voucherSelectedIpd={voucherSelectedIpd} />}
        </>
    )
};

export default IpdRelease;